import { ServerMediaAsset } from '@/lib/janitsjar/Product';
import MuxPlayer from '@mux/mux-player-react';
import React, { useEffect, useRef } from 'react';
import { extractPlaybackId } from '@/components/newImageCarousel/helpers';
import Image from 'next/image';
import { PlayIcon } from '@heroicons/react/20/solid';

type VideoThumbnailProps = {
  media: ServerMediaAsset;
};

export default function VideoThumbnail({ media }: VideoThumbnailProps) {
  const imageUrl =
    media.type === 'video'
      ? `https://image.mux.com/${extractPlaybackId(
          media.url
        )}/thumbnail.png?width=500&height=500&fit_mode=smartcrop`
      : media.url;

  return (
    <div className="relative w-full h-full overflow-hidden">
      <Image
        src={imageUrl}
        alt="Carousel image"
        fill
        className="object-cover"
      />
      <div className="absolute w-full h-full inset-0 flex justify-center items-center">
        <PlayIcon className="size-[10%] text-white" />
      </div>
    </div>
  );
}
